import { SectionTitle } from "@sprout/typography";
import { SecondaryButton } from "@sprout/buttons";
import { IconButton } from "@sprout/icon_button.tsx";
import EditIcon from "@sprout/icons/edit";
import useTranslation from "@hooks/use_translation.ts";

type Props = {
  title: string;
  editLabel: string;
  onEdit: () => void;
  isEmpty: boolean;
  className?: string;
  children: React.ReactNode;
};

const SectionCard = ({ title, editLabel, onEdit, isEmpty, className, children }: Props) => {
  const { t } = useTranslation("user", { keyPrefix: "profile_sections" });

  return (
    <section className={`h-fit rounded-lg bg-white p-4 ${className ?? ""}`}>
      <div className="flex items-start justify-between gap-2">
        <SectionTitle medium>{title}</SectionTitle>
        {!isEmpty && <IconButton icon={EditIcon} size="sm" label={editLabel} onClick={onEdit} />}
      </div>
      <div className="mt-3">
        {isEmpty ? (
          <SecondaryButton size="small" onClick={onEdit} ariaLabel={editLabel}>
            {t("add_details")}
          </SecondaryButton>
        ) : (
          children
        )}
      </div>
    </section>
  );
};

export default SectionCard;
